import { css, Global } from '@emotion/react'
import { ReactNode } from 'react'

import { useScreenScale } from '../hooks/useScreenScale'

interface PainelScaledLayoutProps {
  children: ReactNode
}

export const PainelScaledLayout = (props: Readonly<PainelScaledLayoutProps>) => {
  const { children } = props
  const { scale, baseWidth, dynamicHeight } = useScreenScale()
  const styles = createStyles(scale, baseWidth, dynamicHeight)

  return (
    <>
      <Global styles={styles.global} />
      <div css={styles.container}>{children}</div>
    </>
  )
}

const createStyles = (scale: number, width: number, height: number) => {
  return {
    global: css`
      body {
        overflow: hidden !important;
      }
    `,
    container: css`
      width: ${width}px;
      height: ${height}px;
      transform: scale(${scale});
      transform-origin: top left;
      display: flex;
      flex-direction: column;
    `,
  }
}
